import { Component, OnDestroy, inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';
import { FilterService } from '../../generic/service/filter.service';

@Component({
    selector: 'filter-size',
    styleUrls: ['./filter.component.scss'],
    template: ` <div class="filter-bar-part filter-pot-size">
        <h4 i18n="Pot size filter@@product.feature.pot.size">Pot size</h4>
        <form
            class="filter-range-form"
            [formGroup]="form"
            (ngSubmit)="onSubmit()">
            <input
                type="text"
                placeholder="From"
                i18n-placeholder="Filter from@@filter.from"
                autocomplete="off"
                [formControl]="form.controls['sizeFrom']"
                pattern="[0-9]*[.,]?[0-9]+" />

            <input
                type="text"
                placeholder="To"
                i18n-placeholder="Filter to@@filter.to"
                autocomplete="off"
                [formControl]="form.controls['sizeTo']"
                pattern="[0-9]*[.,]?[0-9]+" />

            <button
                class="button theme-btn-secondary"
                type="submit"
                i18n="filter submit button@@filter.submit.button">
                OK
            </button>
        </form>
    </div>`,
    standalone: true,
    imports: [FormsModule, ReactiveFormsModule],
})
export class FilterSizeComponent implements OnDestroy {
    private filterService = inject(FilterService);
    private formBuilder = inject(UntypedFormBuilder);

    form: UntypedFormGroup;

    private filterStateChangedSubscription: Subscription;

    constructor() {
        const filterState = this.filterService.getFilterState();

        this.form = this.formBuilder.group({
            sizeFrom: [filterState.potSizeFrom],
            sizeTo: [filterState.potSizeTo],
        });

        this.filterStateChangedSubscription =
            this.filterService.filterStateChanged.subscribe(newState => {
                this.form.get('sizeFrom')?.setValue(newState.potSizeFrom);
                this.form.get('sizeTo')?.setValue(newState.potSizeTo);
            });
    }

    ngOnDestroy(): void {
        this.filterStateChangedSubscription.unsubscribe();
    }

    onSubmit() {
        const filterState = this.filterService.getFilterState();

        if (this.form.invalid) {
            return;
        }

        const formValues = this.form.value;

        // Check if one of the values has changed
        if (
            formValues.sizeFrom !== filterState.potSizeFrom ||
            formValues.sizeTo !== filterState.potSizeTo
        ) {
            this.filterService.setPotSize(
                formValues.sizeFrom,
                formValues.sizeTo,
            );
        }
    }
}
